import { gql } from '@apollo/client';

export default gql`
  mutation createTemplate(
    $name: String!
    $templateFields: [TemplateFieldInput!]!
    $periodNumber: Int
    $periodCycle: String
  ) {
    createTemplate(
      input: {
        name: $name
        templateFields: $templateFields
        periodNumber: $periodNumber
        periodCycle: $periodCycle
      }
    ) {
      template {
        id
        name
      }
    }
  }
`;
